require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-construction-begins-at-toorak-residence.json") })
        }
      }, "path---journal-construction-begins-at-toorak-residence");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-construction-begins-at-toorak-residence!./.cache/json/journal-construction-begins-at-toorak-residence.json
// module id = 471
// module chunks = 231608221292675